/**
 * Copyright(c) 2018, DeCurtis Corporation.All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * File name: initialState.js
 * Author   : DeCurtis Team
 * Creation Date: 01/08/18 3:00 AM
 *
 */

export default {
  searchResults: {}
}
